<page-content>
  <ng-container *ngIf="myPackage?.ibexInfo">
    <div class="col">
      <mat-card appearance="outlined">
        <mat-card-title>{{'packages.ibexsmart.general' | translate}}</mat-card-title>
        <ng-container *ngFor="let key of generalFieldNames">
          <smart-input [(model)]="myPackage" [hasTrash]="true" [key]="key" hintTranslationPrefix="packages.ibexinfo.hints"
                       jsonPointerKey="/ibexInfo" translationPrefix="packages.ibexinfo"></smart-input>
        </ng-container>
      </mat-card>
    </div>
  </ng-container>
  <div class="button-right-container">
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{'general.save' | translate}}</button>
  </div>
</page-content>
